(function () {
	// globals
	EWO.ToolSezioni = {};

	// utility functions
	function handleFileSelect(event) {
		const file = event.target.files[0];
		const importBtn = $('.js-import-sections');
		importBtn.prop('disabled', !file);
	}

	// app functions
	EWO.ToolSezioni.rederToolSezioni = function (ctx) {
		var urlQueryString = new URLSearchParams(ctx.querystring);
		var filter = Object.fromEntries(urlQueryString);
		$.extend(filter, ctx.params);
		$.get('/version.json')
			.done(function (version) {
				$('.js-page-container').html(ejs.rr('/app/election/operations/templates/toolSezioni.ejs', { version: version }));
				refreshUsers();
			});

		EWO.ToolSezioni.filter = filter;
	}
	async function refreshUsers() {
		const electionId = EWO.ToolSezioni.filter.electionId;
		EWO.ToolSezioni.filter.allUsers = [];
		const allUsers = EWO.ToolSezioni.filter.allUsers;
		$('.js-users-log-content').text("Loading...");
		try {

			const response = await $.ajax({
				url: `/api/v1/Boundaries?electionId=${electionId}`,
				type: 'GET'
			});
			allUsers.push(...response.rows);

			renderLogUsersFiltered(allUsers, '');
		} catch (error) {
			// Gestione degli errori
			console.error('Errore durante il recupero dei dati:', error);
		}
	}
	function renderLogUsersFiltered(allUsers, filter) {
		const logUsers = [];
		const header = ['idUser', 'username', 'email', 'constituency'];
		const columnWidths = [10, 20, 30, 20]; // Larghezza di ogni colonna

		// Aggiungi l'intestazione con padding
		logUsers.push(header.map((col, index) => col.padEnd(columnWidths[index])).join('\t'));

		const usersFiltered = allUsers.filter(user => user.username.toUpperCase().includes(filter.toUpperCase()));
		for (const user of usersFiltered) {
			// Aggiungi ogni riga con padding
			logUsers.push([
				user.id.toString().padEnd(columnWidths[0]),
				user.username.padEnd(columnWidths[1]),
				user.email?user.email.padEnd(columnWidths[2]):'-'.padEnd(columnWidths[2]),
				user.municipalityDesc.padEnd(columnWidths[3])
			].join('\t'));
		}
		logUsers.push('');
		logUsers.push(`Numero totale di utenti: ${usersFiltered.length}`);
		const logContentUsers = logUsers.map(line => line.trim()).join('\n');
		$('.js-users-log-content').text(logContentUsers);
	
	}
	// funzione che aggiunge una riga rossa .js-users-log-content la riga è un input
	function logUserSendResult(riga,type='secondary') {
		// aggiungo a .js-users-log-content la riga
		$('.js-users-log-content').append(`<div class="alert alert-${type}">${riga}</div>`);
		// scrolla verso l'ultima riga
	    $('.js-users-log-container').scrollTop($('.js-users-log-container')[0].scrollHeight);
	}
	// events

	$(document).on('click', '.js-export-sections', function (ev) {
		ev.preventDefault();
		const electionId = EWO.ToolSezioni.filter.electionId;
		window.location.href = `/api/v1/Constituencies/exportSections?electionId=${electionId}&format=xlsx`;
	});

	$(document).on('change', '.js-section-file', handleFileSelect);

	$(document).on('click', '.js-import-sections', function (ev) {
		ev.preventDefault();
		const electionId = EWO.ToolSezioni.filter.electionId;
		const fileInput = $('.js-section-file')[0];
		const file = fileInput.files[0];

		if (!file) return;

		const formData = new FormData();
		formData.append('formFile', file);

		$.ajax({
			url: `/api/v1/Constituencies/uploadSections?electionId=${electionId}`,
			type: 'POST',
			data: formData,
			processData: false,
			contentType: false,
			success: function (response) {
				// Formatta il log
				const logContent = response.map(line => line.trim()).join('\n');

				// Mostra il riquadro del log
				$('.js-log-content').text(logContent);
				$('.js-import-log').removeClass('d-none');

				// Evidenzia il risultato finale
				const successLine = response[response.length - 1];
				if (successLine.includes('0 Errors')) {
					// alert(i18next.t('Importazione completata con successo'));
				} else {
					alert(i18next.t('Importazione completata con errori'));
				}
			},
			error: function () {
				alert(i18next.t('Errore durante l\'importazione'));
			}
		});
	});

	// Aggiungi handler per chiudere il log
	$(document).on('click', '.js-close-log', function (ev) {
		ev.preventDefault();
		$('.js-import-log').addClass('d-none');
		$('.js-log-content').text('');
	});

	//routes
	page('/election/:electionId/toolSezioni', EWO.ToolSezioni.rederToolSezioni);


})();
// test